import {Icon, Badge, view, Tooltip} from '@sail/ui';
import {check, cancel, info} from '@sail/icons/react/Icon';
import {defineMessages, useIntl} from 'react-intl';

type ChargeCardStatusBadgeProps = {
  status: string;
};

const messages = defineMessages({
  succeeded: {
    id: 'conversations_ui.charge_card.succeeded',
    description: 'Succeeded status',
    defaultMessage: 'Succeeded',
  },
  pending: {
    id: 'conversations_ui.charge_card.pending',
    description: 'Pending status',
    defaultMessage: 'Pending',
  },
  failed: {
    id: 'conversations_ui.charge_card.failed',
    description: 'Failed status',
    defaultMessage: 'Failed',
  },
});

export const ChargeCardStatusBadge = ({status}: ChargeCardStatusBadgeProps) => {
  const intl = useIntl();

  let icon;
  let type: 'positive' | 'neutral' | 'negative';
  let statusText;

  if (status === 'succeeded') {
    icon = check;
    type = 'positive';
    statusText = intl.formatMessage(messages.succeeded);
  } else if (status === 'pending') {
    icon = info;
    type = 'neutral';
    statusText = intl.formatMessage(messages.pending);
  } else if (status === 'failed') {
    icon = cancel;
    type = 'negative';
    statusText = intl.formatMessage(messages.failed);
  } else {
    return null;
  }

  if (icon && type && statusText) {
    return (
      <view.div
        css={{
          display: 'flex',
          width: '100%',
        }}
      >
        <Tooltip
          trigger={
            <Badge
              type={type}
              css={{
                maxWidth: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <view.span
                css={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  minWidth: 0,
                }}
              >
                {statusText}
              </view.span>
              <view.span
                css={{
                  marginLeft: 'xxsmall',
                  display: 'flex',
                  flexShrink: 0,
                }}
              >
                <Icon icon={icon} size="xsmall" />
              </view.span>
            </Badge>
          }
        >
          {statusText}
        </Tooltip>
      </view.div>
    );
  }
};
